export type ColumnMismatch = {
  expected: string[];
  actual: string[];
  missing: string[];
  unexpected: string[];
};

const MISMATCH_RE =
  /The uploaded file columns do not match the datasource headers\s*\[([^\]]*)\]\.\s*First row:\s*(.+)$/i;

const splitBracketList = (raw: string): string[] =>
  raw
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean);

/** Split a CSV header row that may use quoted or bare tokens. */
const splitFirstRow = (raw: string): string[] => {
  const tokens: string[] = [];
  const re = /"([^"]*)"|([^,\s][^,]*)/g;
  let match: RegExpExecArray | null;
  while ((match = re.exec(raw)) !== null) {
    tokens.push((match[1] ?? match[2] ?? '').trim());
  }
  return tokens.filter(Boolean);
};

/**
 * Parses the BFF column-mismatch error into expected vs actual headers.
 * Returns null when the message does not match the known format.
 */
export const parseColumnMismatchMessage = (message: string | undefined | null): ColumnMismatch | null => {
  if (!message) return null;
  const match = MISMATCH_RE.exec(message.trim());
  if (!match) return null;

  const expected = splitBracketList(match[1] ?? '');
  const actual = splitFirstRow(match[2] ?? '');
  const expectedSet = new Set(expected);
  const actualSet = new Set(actual);

  return {
    expected,
    actual,
    missing: expected.filter((h) => !actualSet.has(h)),
    unexpected: actual.filter((h) => !expectedSet.has(h)),
  };
};
